import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import type { ExternalResponse, GiftDetail } from '@/shared/@types';

import { detail, goods } from '@/shared/apis/gift';

/** 전역 객체에서 Gift 데이터 가져오기 */
const getGiftFromWindow = (): GiftDetail | undefined => window.__MSS_FE__?.gift;

export const giftQueryFactory = {
  all: () => ['gift'],
  detailKey: (giftNo: number) => [...giftQueryFactory.all(), 'detail', giftNo],
  detail: (giftNo: number) => {
    const cachedData = getGiftFromWindow();

    return queryOptions({
      queryKey: giftQueryFactory.detailKey(giftNo),
      queryFn: cachedData
        ? () =>
            Promise.resolve({
              data: cachedData,
              meta: { result: 'success', errorCode: null, message: '' },
            } as ExternalResponse<GiftDetail>)
        : () => detail(giftNo),
      select: (data) => data.data,
      staleTime: Infinity,
      gcTime: Infinity,
    });
  },
  goods: (giftNo: number) =>
    infiniteQueryOptions({
      queryKey: [...giftQueryFactory.all(), 'goods', giftNo],
      queryFn: ({ pageParam }) => goods(giftNo, pageParam),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: ({ meta: { pagination } }) => {
        if (!pagination.hasNext) {
          return undefined;
        }
        return pagination.nextCursor ?? undefined;
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
